export const SIGN_IN = "SIGN_IN";
export const SIGN_OUT = "SIGN_OUT";
export const REDUCER_TYPE = "REDUCER_TYPE";
